export default __webpack_public_path__ + "static/media/bg-pattern-hero-about-desktop.3239891f.svg";